import { render, staticRenderFns } from "./RegistrationFieldInputs.vue?vue&type=template&id=a9fdb95c&scoped=true&lang=pug&"
import script from "./RegistrationFieldInputs.vue?vue&type=script&lang=js&"
export * from "./RegistrationFieldInputs.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFieldInputs.vue?vue&type=style&index=0&id=a9fdb95c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fdb95c",
  null
  
)

/* custom blocks */
import block0 from "./RegistrationFieldInputs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports